import React, { useMemo } from 'react'
import { vitalUnitListEmpty, vitalUnitListMetric, vitalUnitListUS } from '../../../Constants';

const Vitals = (props) => {
  let { widgetsPreviewData: Data } = props;
  let { searchParamVitalUnitType } = Data;
  let noValExistText = <p className="text ar-light-color">No data recorded</p>;

  let systemVitals = Data?.dataVital?.[0]?.Vital?.reduce((acc, curr) => {
    acc[curr.VitalName] = curr.VitalValue;
    return acc;
  }, {});
  let vitalData = Data?.vitalData?.reduce((acc, curr) => {
    acc[curr.VitalName] = curr.VitalValue || systemVitals?.[curr.VitalName];
    return acc;
  }, {});



  const vitalUnitList = useMemo(() => {
    if (searchParamVitalUnitType === "US Customary") {
      return vitalUnitListUS;
    } else if (searchParamVitalUnitType === "Metric") {
      return vitalUnitListMetric;
    }
    return vitalUnitListEmpty; // fallback empty object
  }, [searchParamVitalUnitType]);

  return (
    <div className="d-flex gap-10">
      <div className="ar-form-counter flex-center">
        <p className='text text-black'>{props?.itemCount}</p>
      </div>
      <div className='d-flex flex-column gap-6 w-100'>
        <p class="heading fs-13">Vitals</p>
        <div className="">
          <p className='text d-flex align-itemes-center gap-1 flex-wrap'>
            {(() => {
              const vitalItems = [
                { key: "Height", label: "Height" },
                { key: "Weight", label: "Weight" },
                { key: "BMI", label: "BMI" },
                { key: "BMI Percentile", label: "BMI Percentile" },
                { key: "BP", label: "BP" },
                { key: "Temperature", label: "Temperature" },
                { key: "Pulse", label: "Pulse" },
                { key: "Respiratory Rate", label: "Respiratory Rate" },
                { key: "O2 Saturation", label: "O2 Saturation" },
                { key: "Pain", label: "Pain" },
                { key: "Head Circumference", label: "Head Circumference" },
              ];

              // Filter only those that have values
              const filledVitals = vitalItems.filter(v => vitalData?.[v.key]);
              if (filledVitals?.length === 0) return noValExistText;
              // Map them into JSX
              return filledVitals.map((v, index) => (
                <React.Fragment key={v.key}>
                  {v.label}:{" "}
                  <span className="heading">
                    {`${vitalData[v.key]} ${vitalUnitList?.[v.key] || ""}`}
                  </span>
                  {index < filledVitals.length - 1 && ", "}
                </React.Fragment>
              ));
            })()}
          </p>

        </div>
      </div>
    </div>
  )
}

export default Vitals